import React from 'react';
import { useMediaQuery } from 'react-responsive';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import WorkIcon from '@material-ui/icons/Work';
import CheckIcon from '@material-ui/icons/Check';

const AboutUs=()=>{
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 1224px)'
      })
      const isTabletOrMobileDevice = useMediaQuery({
        query: '(max-device-width: 1224px)'
      })

    return(
        <div>
        {
            isDesktopOrLaptop &&
            
            <div id="whytoshop">
             <h2 style={{textAlign :"center",paddingTop:"20px",fontFamily:"Lobester"}} className="ss">Say Yes to shop with Siri Jewellers , Why?</h2>
              <div class="row" style={{marginTop:"25px"}}>
                  
                  <div className="col box" >
                  <CheckIcon style={{fontSize:"40px",marginBottom:"15px"}}/>
                      <h3>100% Quality</h3>
                      <p>At Siri Jewellers,You find 100% quality gold ornaments at reasonable prices.You can find all new models here.</p>   
                  </div>

                 <div className="col box ">
                  <AccessTimeIcon style={{fontSize:"40px",marginBottom:"15px"}}/>
                      <h3>With in 5 days</h3>
                       <p>If you have fantasy of wearing a unique model.We are ready to take orders and deliver you with in 5 days..</p>
                       <p><u>Note</u>:Orders will be accepted only offline.</p>   
                 </div>

                  <div className="col box ">
                  <WorkIcon style={{fontSize:"40px",marginBottom:"15px"}}/>
                     <h3>Service</h3>
                     <p>Once you buy the items.Service is free for your items.</p>   
                 </div>

             </div> 
             <h3 style={{textAlign:"center",fontFamily:"Lobster"}}>Chocolates and flowers die and get eaten,but jewellery is forever.</h3>
         </div>  
        }
        
        {
            isTabletOrMobileDevice && 
            <div id="whytoshop">
             <h2 style={{textAlign :"center",paddingTop:"20px",fontFamily:"Lobester"}} className="ss">Say Yes to shop with Siri Jewellers , Why?</h2>
              <div class="row" style={{marginTop:"25px",padding:"20px"}}>
                  
                  <div className=" box" >
                  <CheckIcon style={{fontSize:"30px",marginBottom:"15px"}}/>
                      <h3>100% Quality</h3>
                      <p>At Siri Jewellers,You find 100% quality gold ornaments at reasonable prices.You can find all new models here.</p>   
                  </div>

                 <div className=" box ">
                  <AccessTimeIcon style={{fontSize:"30px",marginBottom:"15px"}}/>
                      <h3>With in 5 days</h3>
                       <p>If you have fantasy of wearing a unique model.We are ready to take orders and deliver you with in 5 days..</p>
                       <p><u>Note</u>:Orders will be accepted only offline.</p>   
                 </div>

                  <div className="box ">
                  <WorkIcon style={{fontSize:"30px",marginBottom:"15px"}}/>
                     <h3>Service</h3>
                     <p>Once you buy the items.Service is free for your items.</p>   
                 </div>

             </div> 
             <h3 style={{textAlign:"center",fontFamily:"Lobster"}}>Chocolates and flowers die and get eaten,but jewellery is forever.</h3>
         </div>  
        }
         
         </div> 
    )
}

export default AboutUs;